<template>
  <div id="dvreg" @click="HideDropdown" class="page-effect">
    <!-- Payment has failed, click below to retry -->

    <div class="success-wrapper-hld">
      <div
        class="modal fade payment-sucess-popup show"
        role="dialog"
        style="display: block; padding-right: 16px"
      >
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content py-3">
            <div class="modal-header pb-0 text-center d-block">
              <div class="mb-4">
                <svg
                  version="1.1"
                  id="Capa_1"
                  width="60px"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <linearGradient
                      id="SVGID_1_"
                      gradientUnits="userSpaceOnUse"
                      x1="-44.3493"
                      y1="615.9688"
                      x2="11.0738"
                      y2="615.9688"
                      gradientTransform="matrix(10.6667 0 0 -10.6667 473.6667 6826.3335)"
                    >
                      <stop offset="0" style="stop-color: #e93e3a" />
                      <stop offset="0.359" style="stop-color: #ed683c" />
                      <stop offset="0.702" style="stop-color: #f3903f" />
                      <stop offset="1" style="stop-color: #fdc70c" />
                    </linearGradient>
                    <path
                      style="fill: url(#SVGID_1_)"
                      d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256
C511.835,114.683,397.317,0.165,256,0z M256,490.667C126.397,490.667,21.333,385.603,21.333,256S126.397,21.333,256,21.333
S490.667,126.397,490.667,256C490.52,385.542,385.542,490.52,256,490.667z"
                    />

                    <linearGradient
                      id="SVGID_2_"
                      gradientUnits="userSpaceOnUse"
                      x1="-44.3493"
                      y1="615.9688"
                      x2="11.0738"
                      y2="615.9688"
                      gradientTransform="matrix(10.6667 0 0 -10.6667 473.6667 6826.3335)"
                    >
                      <stop offset="0" style="stop-color: #e93e3a" />
                      <stop offset="0.359" style="stop-color: #ed683c" />
                      <stop offset="0.702" style="stop-color: #f3903f" />
                      <stop offset="1" style="stop-color: #fdc70c" />
                    </linearGradient>
                    <path
                      style="fill: url(#SVGID_2_)"
                      d="M376.683,120.235L256,240.917L135.317,120.235l-15.083,15.093L240.917,256L120.235,376.672
l15.083,15.093L256,271.083l120.683,120.683l15.083-15.093L271.083,256l120.683-120.672L376.683,120.235z"
                    />
                  </g>
                </svg>
              </div>
              <h4 class="">Payment Failed</h4>
              <p>Please check your email for instructions.</p>
            </div>
            <div class="modal-body">
              <div class="btn-section text-center btn-theme">
                <router-link
                  :to="getPaymentRetryUrl"
                  class="btn text-uppercase space-button"
                  >Go back to Payment page</router-link
                >
                <!-- Go back to Registration page -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>

<script>
//import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;

export default {
  mounted() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },
  computed: {
    getPaymentRetryUrl() {
      if (this.$route.params.e && this.$route.params.eid) {
        return (
          "/paymentstatus/" +
          this.$route.params.e +
          "/" +
          this.$route.params.eid
        );
      } else if (this.$route.params.e) {
        return "/eventv3/" + this.$route.params.e;
      } else {
        return "/events/";
      }
    },
  },
};
</script>